import React from 'react';
import { ButtonIcon } from '../ButtonIcon';
import { Download } from '../buttons';
import { AddUserSVG, RefreshSVG } from '../svg';
import '../../styles/sass/global/components/filters.scss';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import enabledPages from '../../constants/pages/enabledPages';
import { useTranslation } from 'react-i18next';

export function HeaderTitle ({ title, add, reset, icon, download, buttonText, href, handleOnClick, UIProps, margBottom, total }) {
    const { t } = useTranslation();
    const showButton = buttonText && (href || handleOnClick);

    return (
        <Box width='100%' display='flex' alignItems='center' justifyContent='space-between' marginTop='1.5rem' >
            <Box display='flex' alignItems='center' style={{ marginLeft: '29px', marginBottom: margBottom || '0px' }}>
                <Box display='flex' alignItems='center'>{icon}</Box>
                <Typography variant='h6' className='headerTitle_typography--title'>{title}</Typography>

            </Box>
            <Box style={{ marginRight: '29px' }}>
                {download && (<ButtonIcon
                    title={t('downloadExcel')}
                    onClick={download}
                    icon={(<Download/>)}
                    disabled={UIProps.isLoading || total === 0}
                />)}
                {
                    reset && (
                        <ButtonIcon
                            className='mr-0 mb-0'
                            title={t('buttons.reset')}
                            icon={(<RefreshSVG style={{ width: '24px', heigth: '24px' }}/>)}
                            onClick={reset}
                        />
                    )
                }
                { enabledPages.enableUsersActions && add && (
                    <ButtonIcon
                        className='mr-0 mb-0'
                        title={t('users.table.menu.add.title')}
                        icon={(<AddUserSVG style={{ width: '24px', heigth: '24px' }}/>)}
                        onClick={add}
                    />
                )}

                {showButton && (
                    <Button href={href} className="button_custom--header w-auto px-4 py-3" onClick={handleOnClick} disabled={UIProps.isLoading}>
                        {UIProps.isLoading ? <CircularProgress size={24} style={{ color: 'white' }} /> : buttonText}
                    </Button>

                )}
            </Box>
        </Box>
    );
}
